import {
  GenericPipelineParameterMappingFragment,
  GenericPipelineParameterMappingSource,
} from '@warebee/frontend/data-access-api-graphql';
import { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import Tag from '../../helpContext/Tag';
import usePipelineTemplateParameterSourceDescriptors from '../templateDescriptors/usePipelineTemplateParameterSourceDescriptors';

export type PipelineTemplateParameterValueWrapProps = PropsWithChildren & {
  value: GenericPipelineParameterMappingFragment;
};

const PipelineTemplateParameterValueWrap: React.FC<
  PipelineTemplateParameterValueWrapProps
> = props => {
  const { t } = useTranslation('app');
  const { value } = props;
  const sourceOptionsMap = usePipelineTemplateParameterSourceDescriptors();
  const sourceOptionSelected =
    sourceOptionsMap[
      value.source ?? GenericPipelineParameterMappingSource.CONSTANT
    ];

  return (
    <div>
      <Tag>{sourceOptionSelected.title}</Tag>
      {sourceOptionSelected.showValueEditor && props.children}
    </div>
  );
};

export default PipelineTemplateParameterValueWrap;
